import { api } from "@/lib/api/client";

import type {
  LotAlerts,
  LotDeclarePayload,
  MovementLot,
  ProductLot,
  ProductLots,
  ProductUnit,
  ProductUnitPayload,
} from "./types";

interface Paginated<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export interface LotListParams {
  search?: string;
  product?: string;
  state?: "expired" | "expiring" | "ok" | "none";
  within?: number;
  include_empty?: boolean;
  page?: number;
  page_size?: number;
  ordering?: string;
}

/** Espace Articles (ADR 0062) : un export par point d'API. */
export const articlesApi = {
  units: async (): Promise<ProductUnit[]> => {
    const { data } = await api.get<ProductUnit[]>("/product-units/");
    return data;
  },
  createUnit: async (payload: ProductUnitPayload): Promise<ProductUnit> => {
    const { data } = await api.post<ProductUnit>("/product-units/", payload);
    return data;
  },
  updateUnit: async (id: string, payload: Partial<ProductUnitPayload>): Promise<ProductUnit> => {
    const { data } = await api.patch<ProductUnit>(`/product-units/${id}/`, payload);
    return data;
  },
  deleteUnit: async (id: string): Promise<void> => {
    await api.delete(`/product-units/${id}/`);
  },
  lots: async (params: LotListParams = {}): Promise<Paginated<ProductLot>> => {
    const { data } = await api.get<Paginated<ProductLot>>("/product-lots/", { params });
    return data;
  },
  lotAlerts: async (): Promise<LotAlerts> => {
    const { data } = await api.get<LotAlerts>("/product-lots/alerts/");
    return data;
  },
  declareLot: async (payload: LotDeclarePayload): Promise<ProductLot> => {
    const { data } = await api.post<ProductLot>("/product-lots/", payload);
    return data;
  },
  updateLot: async (
    id: string,
    payload: { lot_number?: string; expiry_date?: string | null },
  ): Promise<ProductLot> => {
    const { data } = await api.patch<ProductLot>(`/product-lots/${id}/`, payload);
    return data;
  },
  productLots: async (productId: string): Promise<ProductLots> => {
    const { data } = await api.get<ProductLots>(`/products/${productId}/lots/`);
    return data;
  },
  reassignLots: async (
    movementId: string,
    picks: { lot: string; quantity: number }[],
  ): Promise<MovementLot[]> => {
    const { data } = await api.post<MovementLot[]>(`/stock-movements/${movementId}/lots/`, { picks });
    return data;
  },
};
